var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFacebook = function SvgFacebook(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12C20 7.584 16.416 4 12 4C7.584 4 4 7.584 4 12C4 15.872 6.752 19.096 10.4 19.84V14.4H8.8V12H10.4V10C10.4 8.456 11.656 7.2 13.2 7.2H15.2V9.6H13.6C13.16 9.6 12.8 9.96 12.8 10.4V12H15.2V14.4H12.8V19.96C16.84 19.56 20 16.152 20 12Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebook);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgyMEMyMi4yMDkxIDAgMjQgMS43OTA4NiAyNCA0VjIwQzI0IDIyLjIwOTEgMjIuMjA5MSAyNCAyMCAyNEg0QzEuNzkwODYgMjQgMCAyMi4yMDkxIDAgMjBWNFoiIGZpbGw9IiMxODc3RjIiLz4KPHBhdGggZD0iTTIwIDEyQzIwIDcuNTg0IDE2LjQxNiA0IDEyIDRDNy41ODQgNCA0IDcuNTg0IDQgMTJDNCAxNS44NzIgNi43NTIgMTkuMDk2IDEwLjQgMTkuODRWMTQuNEg4LjhWMTJIMTAuNFYxMEMxMC40IDguNDU2IDExLjY1NiA3LjIgMTMuMiA3LjJIMTUuMlY5LjZIMTMuNkMxMy4xNiA5LjYgMTIuOCA5Ljk2IDEyLjggMTAuNFYxMkgxNS4yVjE0LjRIMTIuOFYxOS45NkMxNi44NCAxOS41NiAyMCAxNi4xNTIgMjAgMTJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";